import React, { useEffect, useMemo, useState } from "react";
import { db } from "../utils/firebase";
import { doc, onSnapshot, setDoc, serverTimestamp } from "firebase/firestore";
import toasted from "../config/toasted";
import { Favorite, FavoriteBorder } from "@mui/icons-material";
import { getAuth } from "firebase/auth";

const LikeButton = ({ card }) => {
      const authInstance = getAuth();

      const promptId = card?.id;
      const userID = authInstance.currentUser?.uid;


      const auth = localStorage.getItem("auth");

      const [liked, setLiked] = useState(false);
      // const [likeCount, setLikeCount] = useState(card?.likes || 0);
      const [loading, setLoading] = useState(false);

      const likeDocId = useMemo(() => {
            if (!promptId || !userID) return null;
            return `${promptId}_${userID}`;
      }, [promptId, userID]);

      // ✅ Realtime: liked status (likes/{promptId_userId})
      useEffect(() => {
            if (!auth || !userID || !promptId || !likeDocId) return;

            const likeRef = doc(db, "likes", likeDocId);

            const unsub = onSnapshot(
                  likeRef,
                  (snap) => setLiked(snap.exists()),
                  (err) => console.error("Like snapshot error:", err)
            );

            return () => unsub();
      }, [promptId, userID, auth, likeDocId]);

      // ✅ Realtime: like count (prompts/{promptId}.likes)
      // useEffect(() => {
      //       if (!promptId) return;

      //       const promptRef = doc(db, "prompts", promptId);

      //       const unsub = onSnapshot(
      //             promptRef,
      //             (snap) => {
      //                   if (!snap.exists()) return;
      //                   const data = snap.data();
      //                   // setLikeCount(typeof data?.likes === "number" ? data.likes : 0);
      //             },
      //             (err) => console.error("Prompt snapshot error:", err)
      //       );

      //       return () => unsub();
      // }, [promptId]);

      // ✅ Handle Like (Cloud Function increments prompt.likes + earnings)
      const handleLike = async () => {
            if (!auth || !userID) {
                  toasted.error("Please login to like prompts.");
                  return;
            }

            if (liked || loading || !promptId || !likeDocId) return;

            try {
                  setLoading(true);

                  const likeRef = doc(db, "likes", likeDocId);

                  // Create like doc (id unique, so duplicate create won't happen)
                  await setDoc(likeRef, {
                        promptId,
                        userId: userID,
                        createdAt: serverTimestamp(),
                  });

                  // liked state will also update via realtime listener
                  toasted.success("ᥫ᭡ Prompt liked!");
            } catch (error) {
                  console.error("Like error:", error);
                  toasted.error("Something went wrong.");
            } finally {
                  setLoading(false);
            }
      };

      return (
            <button
                  type="button"
                  onClick={handleLike}
                  disabled={liked || loading}
                  className={`card-feature-btn card-likes ${liked ? "liked" : ""} ${loading ? "loading" : ""
                        }`}
                  style={{ cursor: liked ? "not-allowed" : "pointer" }}
                  aria-pressed={liked}
                  aria-label={liked ? "Liked" : "Like"}
            >
                  {liked ? <Favorite /> : <FavoriteBorder />}
            </button>
      );
};

export default LikeButton;